import { createIcon } from '@chakra-ui/react'

export const ArrowSvg = createIcon({
  displayName: 'ArrowSvg',
  viewBox: '0 0 15 9',
  path: (
    <svg fill="none">
      <line
        x1="13.9257"
        y1="1.91226"
        x2="7.63448"
        y2="7.57433"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="1"
        y1="-1"
        x2="9.46393"
        y2="-1"
        transform="matrix(0.743294 0.668965 0.668965 -0.743294 1 0.5)"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
})
